<template>
  <div>
    <div>
      Password expires on:
    </div>
    <div
      v-cloak
      :class="[$style.passwordExpirationDate, dateColor]"
    >
      {{ dateLabel }}
    </div>
  </div>
</template>

<script>
import Constants from 'client/util/Constants';
import moment from 'moment';

const { dateFormat, dataNotAvailable } = Constants;

export default {
  name: 'PasswordExpirationLabelText',

  props: {
    activated: {
      type: Boolean,
      default: false,
    },
    enablePasswordExpirationInDays: {
      type: [String, Boolean],
      default: false,
    },
    passwordExpirationDate: {
      type: [String, Date],
      default: dataNotAvailable,
    },
    passwordExpirationDateSelected: {
      type: Boolean,
      default: false,
    },
    passwordExpirationInDays: {
      type: [String, Number],
      default: 0,
    },
  },

  computed: {
    dateColor() {
      if (!this.passwordExpirationDate || this.passwordExpirationDate === dataNotAvailable) {
        return this.$style.safe;
      }

      const expiry = moment(this.passwordExpirationDate);
      const { now } = this.$options;
      const diffHours = expiry.diff(now, 'hours');
      const hoursInWeek = 168;
      const hoursInDay = 24;

      if (diffHours > hoursInWeek) return this.$style.safe;

      return diffHours < hoursInDay ? this.$style.danger : this.$style.warn;
    },
    dateLabel() {
      if (this.passwordExpirationDate === dataNotAvailable
          || !this.passwordExpirationDateSelected) {
        return dataNotAvailable;
      }

      if (!this.passwordExpirationDate) {
        return this.$options.now.clone().add(this.passwordExpirationInDays, 'days').format(dateFormat);
      }

      return moment(this.passwordExpirationDate).format(dateFormat);
    },
  },

  now: moment(),
};
</script>

<style module>
@import '../../../components/FormValidation/css/formFields.css';

@value (jcOrange, red) from '~css/colors.css';

.passwordExpirationDate {
  font-size: larger;
  font-weight: 555;
  margin-top: 5px;
}

.safe {
  color: inherit;
}

.warn {
  color: jcOrange;
}

.danger {
  color: red;
}

[v-cloak] {
  display: none;
}
</style>
